module.exports = __webpack_public_path__ + "img/ai-compare-history-no-result.d60263bf.svg";